<form [ngClass]="this.partnerType=='SYSTEM'?'g-4':'g-3'" class="row mt-3 border border-dark bg-white rounded border-1 p-2" (ngSubmit)="onLoadStates()" [formGroup]="stateForm">

  <div class="form-floating col ">
    <input type="date" class="form-control" placeholder="Date de d&#233;part" id="start" formControlName="start">
    <label for="startDate" class="form-label">Date de d&#233;part</label>
  </div>
  <div class="form-floating col">

    <input type="date" class="form-control mr-4" id="endDate" placeholder="Date de fin" formControlName="end"
      name="end">
    <label for="endDate" class="form-label">Date de fin</label>
  </div>
  @if (this.partner?.canBeParent==true) {
    <div class="form-floating col">
      <select class="form-select" formControlName="idPartner" name="partner" id="idPartner">
        <option>Veuillez choisir un partenaire</option>
        @for (merch of merchants; track merch) {
          <option value="{{merch.id}}">{{merch.name}}</option>
        }
      </select>
      <label for="idPartner" class="form-label">Partenaire</label>
    </div>
  }
  @if (this.partner?.canBeParent==true) {
    <input  type="hidden" class="form-control mr-4" id="idPartner" formControlName="idPartner" name="idPartner"
      value="{{this.idPartner}}">
  }
  <div class="col justify-content-end">
    <button type="submit" class="btn btn-success mt-2 w-100">Valider</button>
  </div>
</form>

<div id="accountHistory" class="row">
  <div class="row mb-2">
    <div class="col  mt-2 justify-content-start">
      <button class="btn border border-dark">
        <i class="fa fa-file-excel-o  mr-2" (click)="exportToExcel()" style="color: green;"
        aria-hidden="false">Exporter</i>
      </button>
      <button class="btn border border-dark ms-2">
        <i class="fa fa-file-pdf-o btn mr-2" (click)="exportToPdf()" style="color: red;" aria-hidden="false">pdf</i>
      </button>
    </div>
  </div>
  <div class="row">


    <table class="table table-bordered table-hover table-striped text-center">
      <thead class="table-success">
        <tr>
          <th class="col">Date</th>
          <th class="col">Montant</th>
          <th class="col">Sens operation</th>
          <th class="col">description</th>
        </tr>
      </thead>
      <tbody>
        @for (state of statements?.content| paginate : pageConfig; track state) {
          <tr>
            <td>{{state.dateWriting}}</td>
            <td>{{abs(state.amount!!)}}</td>
            @if (state.amount!!>0) {
              <td>CREDIT</td>
            }
            @if (state.amount!!<0) {
              <td>DEBIT</td>
            }
            <td>{{state.description}}</td>
          </tr>
        }
      </tbody>
      <div class="d-flex justify-content-center">
        <pagination-controls previousLabel="Precedent" nextLabel="Suivant" (pageChange)="onNextPage($event)">
        </pagination-controls>
      </div>
    </table>

  </div>
</div>